import {
  LayoutDashboard,
  ShoppingCart,
  FileText,
  Truck,
  Receipt,
  BarChart3,
  Building2,
  Users,
  AlertTriangle,
  type LucideIcon,
} from 'lucide-react';
import { Permission } from '@/types/auth';

export interface NavItem {
  id: string;
  label: string;
  href: string;
  icon: LucideIcon;
  permissions?: Permission[];
  children?: NavItem[];
}

export const supplierNavigation: NavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    href: '/',
    icon: LayoutDashboard 
  },
  {
    id: 'sourcing',
    label: 'Sourcing Events',
    href: '/sourcing',
    icon: ShoppingCart,
    permissions: [Permission.VIEW_SOURCING_EVENTS],
    children: [
      {
        id: 'sourcing-available',
        label: 'Available Events',
        href: '/sourcing/available',
        icon: ShoppingCart,
        permissions: [Permission.VIEW_SOURCING_EVENTS] 
      },
      {
        id: 'sourcing-bids',
        label: 'My Bids',
        href: '/sourcing/bids',
        icon: FileText,
        permissions: [Permission.SUBMIT_BIDS] 
      },
      {
        id: 'sourcing-history',
        label: 'Bid History',
        href: '/sourcing/history',
        icon: FileText,
        permissions: [Permission.VIEW_SOURCING_EVENTS] 
      },
    ],
  },
  {
    id: 'orders',
    label: 'Orders',
    href: '/orders',
    icon: FileText,
    permissions: [Permission.VIEW_SUPPLIER_ORDERS],
    children: [
      {
        id: 'orders-pos',
        label: 'Purchase Orders',
        href: '/orders/purchase-orders',
        icon: FileText,
        permissions: [Permission.VIEW_SUPPLIER_ORDERS] 
      },
      {
        id: 'orders-pending',
        label: 'Resolution Center',
        href: '/orders/pending-actions',
        icon: AlertTriangle,
        permissions: [Permission.VIEW_SUPPLIER_ORDERS] 
      },
      {
        id: 'orders-delivery',
        label: 'Delivery Schedule',
        href: '/orders/delivery',
        icon: Truck,
        permissions: [Permission.VIEW_SUPPLIER_ORDERS] 
      },
      {
        id: 'orders-invoices',
        label: 'Invoices',
        href: '/orders/invoices',
        icon: Receipt,
        permissions: [Permission.VIEW_SUPPLIER_ORDERS] 
      },
    ],
  },
  {
    id: 'performance',
    label: 'Performance',
    href: '/performance',
    icon: BarChart3,
    permissions: [Permission.VIEW_SUPPLIER_ORDERS],
    children: [
      {
        id: 'performance-scorecard',
        label: 'Scorecard',
        href: '/performance/scorecard',
        icon: BarChart3,
        permissions: [Permission.VIEW_SUPPLIER_ORDERS] 
      },
      {
        id: 'performance-feedback',
        label: 'Feedback',
        href: '/performance/feedback',
        icon: FileText,
        permissions: [Permission.VIEW_SUPPLIER_ORDERS] 
      },
    ],
  },
  {
    id: 'company',
    label: 'Company',
    href: '/company',
    icon: Building2,
    permissions: [Permission.MANAGE_SUPPLIER_PROFILE],
    children: [
      {
        id: 'company-profile',
        label: 'Profile',
        href: '/company/profile',
        icon: Building2,
        permissions: [Permission.MANAGE_SUPPLIER_PROFILE] 
      },
      {
        id: 'company-certifications',
        label: 'Certifications',
        href: '/company/certifications',
        icon: FileText,
        permissions: [Permission.MANAGE_SUPPLIER_PROFILE] 
      },
      {
        id: 'company-zones',
        label: 'Delivery Zones',
        href: '/company/zones',
        icon: Truck,
        permissions: [Permission.MANAGE_SUPPLIER_PROFILE] 
      },
      {
        id: 'company-users',
        label: 'Users',
        href: '/company/users',
        icon: Users,
        permissions: [Permission.MANAGE_SUPPLIER_PROFILE] 
      },
    ],
  },
];
